<template>
    <div class="page-container">
        <el-card shadow="never" class="main-card">
            <!-- 查询条件区 + 操作按钮 -->
            <div class="search-bar">
                <el-input v-model="queryCon.roleName" placeholder="角色名称" style="width:200px;" />
                <el-button-group>
                    <el-button type="primary" :icon="Search" @click="handler.queryHandler">查询</el-button>
                    <el-button :icon="RefreshRight" @click="resetQueryCon">重置</el-button>
                </el-button-group>
                <div class="action-bar">
                    <el-button type="primary" plain :icon="CirclePlusFilled" @click="handler.addHandler">新增</el-button>
                    <el-button type="danger" plain :icon="Delete" @click="handler.deleteBatchHandler">删除</el-button>
                </div>
            </div>

            <!-- 表格区 -->
            <div class="table-wrapper">
                <el-table :data="tableData" v-loading="tableLoading" height="100%" row-key="id" ref="dataTableRef"
                    class="modern-table"
                    :header-cell-style="{ background: '#fafafa', color: '#909399', fontWeight: 500 }">
                    <el-table-column type="selection" width="40" />
                    <el-table-column prop="roleName" label="角色名称" />
                    <el-table-column prop="roleType.desc" label="角色类型" />
                    <el-table-column prop="remark" label="角色备注" />
                    <el-table-column prop="modifyName" label="修改人" width="120" />
                    <el-table-column prop="modifyDate" label="修改日期" width="180" />
                    <el-table-column label="操作" width="110" fixed="right" header-align="center">
                        <template #default="scope">
                            <el-button size="small" circle :icon="Edit" @click="handler.editHandler(scope.row)" />
                            <el-button size="small" circle type="danger" :icon="Delete" @click="handler.deleteHandler(scope.row)" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
                <el-pagination background v-model:current-page="queryCon.currentPage" v-model:page-size="queryCon.pageSize"
                    :page-sizes="pagination.pageInfo.pageSizes" layout="total, sizes, prev, pager, next"
                    :total="pagination.pageInfo.total" @size-change="pagination.handleSizeChange"
                    @current-change="pagination.handleCurrentChange" />
            </div>
        </el-card>

        <el-dialog v-model="dialogFormVisible" title="新建/编辑" width="700">
            <el-form :model="form" :label-position="'top'" :rules="rules" status-icon ref="dataFormRef">
                <el-form-item v-show="false" label="id" prop="id">
                    <el-input v-model="form.id"></el-input>
                    <el-input v-model="form.roleType"></el-input>
                </el-form-item>
                <el-form-item label="角色名" prop="roleName">
                    <el-input v-model="form.roleName" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="角色类型" prop="roleType.code">
                    <el-select placeholder="角色类型" v-model="form.roleType.code" class="el-input-width">
                        <el-option label="管理角色" :value="0"></el-option>
                        <el-option label="业务角色" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="角色备注" prop="remark">
                    <el-input v-model="form.remark" autocomplete="off" class="el-input-width" />
                </el-form-item>
                <el-form-item label="角色权限">
                    <el-tree ref="treeRef" :data="permissionData"
                        style="border:1px solid #ccc;width: 500px;height:200px;overflow: auto;"
                        :props="{ children: 'children', label: 'funName' }" :check-strictly="true" node-key="id"
                        show-checkbox="true"></el-tree>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="handler.saveHandler">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<style lang="css" scoped>
@import '../../../src/assets/styles/common.css';
</style>

<script setup>
import { nextTick, ref, reactive, onMounted } from 'vue';
import "@/assets/styles/crud-page.css";
import { ElTable, ElMessageBox, ElMessage } from 'element-plus';
import 'element-plus/dist/index.css';
import { Delete, CirclePlusFilled, Search, Edit, RefreshRight } from "@element-plus/icons-vue";
import { roleApi } from '@/api/role-api.js';

import { getUserInf } from '@/shard/login-info-manager.js';

//状态标志
const dialogFormVisible = ref(false);
const tableLoading = ref(false);

//数据
const permissionData = ref([]);
const tableData = ref([]);

//引用
const dataTableRef = ref(null);
const dataFormRef = ref(null);
const treeRef = ref(null);

//查询条件与分页
//默认选中当前帐号所属的机构
const queryCon = reactive({ roleName: '',  pageSize: 10, currentPage: 1 });
const queryConResetVal = { ...queryCon };
const resetQueryCon = () => {
    Object.assign(queryCon, queryConResetVal);
};
const pagination = {
    pageInfo: reactive({
        total: 0,
        pageSizes: [10, 20, 30, 50, 100]
    }),
    handleSizeChange: (val) => {
        queryCon.pageSize = val;
        handler.queryHandler();
    },
    handleCurrentChange: (val) => {
        queryCon.currentPage = val;
        handler.queryHandler();
    }
}

//表单对象
const form = reactive({
    id: '',
    roleName: '',
    remark: '',
    roleType: {code: null},
    permissionIds: []
});
const resetForm = () => {
    dataFormRef.value?.resetFields();
    treeRef.value?.setCheckedKeys([], false);
}
const rules = {
    roleName: [
        { required: true, message: '角色名不能为空', trigger: 'blur' }
    ],
    "roleType.code": [
        { required: true, message: '请选择角色类型', trigger: 'blur' }
    ]
};

async function init() {
    //登录帐自身的权限范围
    roleApi.getRolePermissions({ roleId: getUserInf().roleId }).then((response) => {
        if (response.data.errorCode === "00000") {
            permissionData.value = response.data.result;
        } else {
            ElMessage.error(`系统异常[加载权限异常 ErrorCode:${response.data.errorCode} ]`);
        }
    })
}

//生命周期
onMounted(async () => {
    await init();
    handler.queryHandler();
})

//UI界面逻辑
const handler = {
    queryHandler() {
        tableLoading.value = true;
        roleApi.pageRole(queryCon).then((response) => {
            if (response.data.errorCode === "00000") {
                tableData.value = response.data.result.records;
                pagination.pageInfo.total = response.data.result.total;
            } else {
                ElMessage.error(`系统异常[ ErrorCode:${response.data.errorCode} ]`);
            }
        })
        .finally(function () {
            tableLoading.value = false;
        });
    },
    addHandler() {
        resetForm();
        treeRef.value?.setCheckedKeys([], false);
        dialogFormVisible.value = true;
    },
    editHandler(rowObj) {
        resetForm();
        dialogFormVisible.value = true;
        nextTick(() => {
            Object.assign(form, rowObj);
        });
        roleApi.getRolePermissionIds({ roleId: rowObj.id }).then((response) => {
            if (response && response.data.errorCode === "00000") {
                treeRef.value.setCheckedKeys(response.data.result, true);
            }
        });
    },
    deleteHandler(rowObj) {
        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        ).then(() => {
            roleApi.deleteRole([rowObj.id])
                .then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '删除成功.', type: 'success' });
                        handler.queryHandler();
                    } else {
                        ElMessage.error(`系统异常[ ErrorCode:${response.data.errorCode} ]`);
                    }
                })
        }).catch(() => {})
    },
    deleteBatchHandler() {
        var selectedRows = dataTableRef.value.getSelectionRows();
        if (selectedRows && selectedRows.length == 0) { ElMessage("没有选中任何行"); return; }

        var ids = [];
        selectedRows.forEach(function (item) {
            ids.push(item.id);
        });

        ElMessageBox.confirm(
            '确认要删除吗?',
            '删除确认',
            {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
            }
        ).then(() => {
            roleApi.deleteRole(ids)
                .then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '删除成功.', type: 'success' });
                        handler.queryHandler();
                    } else {
                        ElMessage.error(`系统异常[ ErrorCode:${response.data.errorCode} ]`);
                    }
                })
        }).catch(() => {})
    },
    saveHandler() {
        dataFormRef.value.validate((valid) => {
            if (valid) {
                //获取选中的节点
                form.permissionIds = treeRef.value.getCheckedKeys(false);
                //获取半选的节点，一般是父节点
                form.permissionIds = form.permissionIds.concat(treeRef.value.getHalfCheckedKeys());
                roleApi.saveRole(form).then((response) => {
                    if (response.data.errorCode === "00000") {
                        ElMessage({ message: '保存成功', type: 'success' });
                        handler.queryHandler();
                        dialogFormVisible.value = false;
                    } else {
                        ElMessage.error("系统出错[errorCode:" + response.data.errorCode + "]");
                    }
                })
            }
        });
    }
}
</script>
